import { AppConfig } from '@/models/app-config';
import { createContext } from 'react';

export const AppContext = createContext<AppConfig | null>(null);
